import React, { useState } from "react";
import _ from "lodash";
import useDarkMode from "./hooks/use-dark-mode";
import { useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import {
  useMediaQuery,
  useTheme,
  createTheme,
  ThemeProvider,
  Paper,
} from "@mui/material";
import { red, grey } from "@mui/material/colors";
import { ToastContainer } from "react-toastify";
//
import Routes, { ROTAS } from "./routers/routes";
import { AnimatePresence } from "framer-motion";

const selectCor = (state) => state?.usuario?.corSecundaria;
// Lista de menus que fazem parte do SPA
const menuSPA = _.map(ROTAS, 0);

function obterCor() {
  const storage = window?.localStorage;
  if (storage) {
    return storage.getItem("_APP_COR_SECUNDARIA") || grey[500];
  }
  return grey[500];
}
//

function App() {
  const [colorPrimary, setColorPrimary] = useState(red["900"]);
  // Escuta mudancas no usuario
  const corSecundaria = useSelector(selectCor) || obterCor();

  // Verifica se e mobile
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  const [darkMode, setDarkMode] = useDarkMode();
  const theme = createTheme({
    isMobile,
    backgroundPage: !darkMode && grey[200],
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: darkMode
        ? {
            main: colorPrimary,
            //main: pink["300"],
          }
        : {
            main: colorPrimary,
            //main: pink["300"],
          },
      secondary: darkMode
        ? {
            main: corSecundaria,
          }
        : {
            main: corSecundaria,
          },
      styleTrSelecionado: {
        backgroundColor: grey["400"],
        color: "black",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="bottom-center" />
      <Paper elevation={0} style={{ minHeight: "100vh" }}>
        <Router>
          <AnimatePresence>
            <Routes
              menuSPA={menuSPA}
              darkMode={darkMode}
              setDarkMode={setDarkMode}
              isMobile={isMobile}
            />
          </AnimatePresence>
        </Router>
      </Paper>
    </ThemeProvider>
  );
}

export default App;
